let navigateFunction = null;
export const setNavigate = (nav) => {
    navigateFunction = nav;
};
// Check if we're in a test environment (JSDOM doesn't support navigation)
const isTestEnv = typeof process !== 'undefined' && process.env.NODE_ENV === 'test';
export const navigationService = {
    push: (path) => {
        if (navigateFunction) {
            navigateFunction(path);
        }
        else if (!isTestEnv) {
            window.location.href = path;
        }
        // In test environment without navigate function, this is a no-op
        // Tests should mock navigationService.push directly
    },
    replace: (path) => {
        if (navigateFunction) {
            navigateFunction(path, { replace: true });
        }
        else if (!isTestEnv) {
            window.location.replace(path);
        }
    },
    goBack: () => {
        if (navigateFunction) {
            navigateFunction(-1);
        }
        else if (!isTestEnv) {
            window.history.back();
        }
    },
};
export default navigationService;
